/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Matrix4 } from 'three';
/**
 * Utility functions for converting Crown-Tranform data to Matrix4 and vice versa
 */
export class CrownTransform {
    /**
     * Convert an object Matrix into CrownTranform arrays
     */
    static toArrays(matrix) {
        const arr = matrix.transpose().toArray();
        return [
            arr.slice(0, 4),
            arr.slice(4, 8),
            arr.slice(8, 12),
            arr.slice(12, 16),
        ];
    }
    /**
     * Convert CrownTranform arrays into an object Matrix
     */
    static createTransformMatrix(transform) {
        const arr = [].concat(transform.Matrix[0], transform.Matrix[1], transform.Matrix[2], transform.Matrix[3]);
        const matrix = new Matrix4();
        matrix.fromArray(arr);
        matrix.transpose();
        return matrix;
    }
    /**
     * Copy the matrix transform to the object and updates the object's position, rotation and scale.
     */
    static copyMatrix(transform, obj3d) {
        if (transform != null) {
            this.createTransformMatrix(transform).decompose(obj3d.position, obj3d.quaternion, obj3d.scale);
            obj3d.updateMatrix();
        }
    }
}
//# sourceMappingURL=CrownTransform.js.map